import React from 'react';

const viVNM: React.FC = () => (
  <svg width='16' height='12' viewBox='0 0 16 12' xmlns='http://www.w3.org/2000/svg' version='1.1'>
    <rect width='16' height='12' fill='#da251d' />
    <polygon points='8,2.4 6.29,8.91 11.04,5.09 4.96,5.09 9.71,8.91' fill='#ff0' />
  </svg>
);

export default viVNM;

